/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Sie können Ihr Fahrzeug nicht finden?`
};

const en_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Can't find your vehicle?`
};

const es_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `¿No encuentra su vehículo?`
};

const fr_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Vous ne trouvez pas votre véhicule ?`
};

const it_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Non riuscite a trovare il vostro veicolo?`
};

const nl_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Kunt u uw voertuig niet vinden?`
};

const pt_register__car__info_box__title = /** @type {(inputs: {}) => string} */ () => {
	return `Não consegue encontrar o seu veículo?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register__car__info_box__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register__car__info_box__title", locale)
	if (locale === "de") return de_register__car__info_box__title(inputs)
	if (locale === "en") return en_register__car__info_box__title(inputs)
	if (locale === "es") return es_register__car__info_box__title(inputs)
	if (locale === "fr") return fr_register__car__info_box__title(inputs)
	if (locale === "it") return it_register__car__info_box__title(inputs)
	if (locale === "nl") return nl_register__car__info_box__title(inputs)
	return pt_register__car__info_box__title(inputs)
};